<template>
    <Head title="Gyms" />

    <BreezeAuthenticatedLayout>
      <main class="container">
        <div class="c-header">
          <a href="" onclick="javascript:history.back(); return false;" class="c-header__back">
            <img src="/images/icons/icon-chevron-left.svg" alt="back">
          </a>
          <h2 class="c-header--h2">ボルダリングジム：登録</h2>
        </div>

        <div class="py-12">

          <div class="mt-24">
            <form @submit.prevent="storeGym">
              <div class="mt-24">
                <label for="title">ジム名称</label>
                <div class="mt-1">
                  <input type="text" id="title" wire:model.lazy="title" name="title" v-model="form.title" />
                </div>
              </div>
              <div class="mt-24">
                <label for="title">URLスラッグ</label>
                <div class="mt-1">
                  <input type="text" id="slug" wire:model.lazy="slug" name="slug" v-model="form.slug" />
                </div>
              </div>
              <div class="mt-24">
                <label for="lead">紹介文</label>
                <div class="mt-1">
                  <textarea id="lead" wire:model.lazy="lead" name="lead" v-model="form.lead"></textarea>
                </div>
              </div>
              <div class="mt-24">
                <label for="link_website">ウェブサイトURL</label>
                <div class="mt-1">
                  <input type="url" id="link_website" wire:model.lazy="link_website" name="link_website" v-model="form.link_website" placeholder="https://" />
                </div>
              </div>
              <div class="mt-24">
                <label for="link_instagram">Instagram URL</label>
                <div class="mt-1">
                  <input type="url" id="link_instagram" wire:model.lazy="link_instagram" name="link_instagram" v-model="form.link_instagram" placeholder="https://" />
                </div>
              </div>
              <div class="mt-24">
                <label for="link_twitter">Twitter URL</label>
                <div class="mt-1">
                  <input type="url" id="link_twitter" wire:model.lazy="link_twitter" name="link_twitter" v-model="form.link_twitter" placeholder="https://" />
                </div>
              </div>
              <div class="mt-24">
                <label for="link_youtube">YouTube URL</label>
                <div class="mt-1">
                  <input type="url" id="link_youtube" wire:model.lazy="link_youtube" name="link_youtube" v-model="form.link_youtube" placeholder="https://" />
                </div>
              </div>
              <div class="mt-24">
                <label for="title">画像</label>
                <div class="mt-1">
                  <input type="file" id="image" wire:model="newImage" name="image" 
                  @input="form.image = $event.target.files[0]" />
                </div>
              </div>
              <div class="mt-24">
                <button type="submit" class="c-button">登録する</button>
              </div>
            </form>
          </div>

        </div>
        <Side />
      </main>
    </BreezeAuthenticatedLayout>
</template>

<script>
  import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue'
  import { Head, Link, useForm } from '@inertiajs/inertia-vue3';
  import Side from '@/Shared/Side'

  export default {
    components: {
      BreezeAuthenticatedLayout,
      Head,
      Link,
      useForm,
      Side
    },

    setup() {
      const form = useForm({
        title: null,
        slug: null,
        lead: null,
        link_website: null,
        link_instagram: null,
        link_twitter: null,
        link_youtube: null,
        image: null,
      });
      return { form };
    },

    methods: {
      storeGym() {
        this.form.post('/gyms')
      }
    }
  }

</script>
